import lockupNavy from "@/assets/brand/axoris-lockup-navy.png";
import lockupWhite from "@/assets/brand/axoris-lockup-white.png";
import markNavy from "@/assets/brand/axoris-mark-navy.png";
import markWhite from "@/assets/brand/axoris-mark-white.png";
import styles from "@/components/sheet/LembarVisual.module.css";

// Keep founder assets intact; the viewport accounts for their transparent padding.
export const BrandLogo = ({ mark = false, tone }) => (
  <span role="img" aria-label="AXORIS" className={`${styles.logo} ${mark ? styles.logoMark : styles.logoLockup}`}>
    {tone === "dark" || tone === "light" ? (
      <img src={mark ? (tone === "dark" ? markWhite : markNavy) : (tone === "dark" ? lockupWhite : lockupNavy)} alt="" />
    ) : <>
      <img src={mark ? markNavy : lockupNavy} alt="" className={styles.logoNavy} />
      <img src={mark ? markWhite : lockupWhite} alt="" className={styles.logoWhite} />
    </>}
  </span>
);
